import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { dvirFormState } from './dvirFormState';
import { DvirFormState } from '../types';

export const dvirFormSlice = createSlice({
  name: 'dvirForm',
  initialState: dvirFormState,
  reducers: {
    setDvirForms: (
      state,
      action: PayloadAction<DvirFormState['dvirForms']>,
    ) => {
      state.dvirForms = action.payload;
    },
    setTotalRecords: (state, action: PayloadAction<number>) => {
      state.totalRecords = action.payload;
    },
    setCreateUpdateDvirFormModal: (
      state,
      action: PayloadAction<DvirFormState['createUpdateDvirFormModal']>,
    ) => {
      state.createUpdateDvirFormModal = action.payload;
    },
  },
});

export const { actions: dvirFormActions } = dvirFormSlice;

export const selectDvirForm = (state: RootState) => state.dvirForm;

export const selectDvirForms = createSelector(
  selectDvirForm,
  state => state.dvirForms,
);

export const selectTotalRecords = createSelector(
  selectDvirForm,
  state => state.totalRecords,
);

export const selectCreateUpdateDvirFormModal = createSelector(
  selectDvirForm,
  state => state.createUpdateDvirFormModal,
);

export default dvirFormSlice.reducer;
